import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaLaptopCode } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import AnimatedSection from './AnimatedSection';

export default function WebPricingPreview() {
  const { t } = useTranslation();
  const plans = [
    { key: 'start', price: '249' },
    { key: 'business', price: '399', featured: true },
    { key: 'shop', price: '599' }
  ];

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute -left-32 top-10 w-80 h-80 bg-primary rounded-full blur-[120px]" />
        <div className="absolute -right-32 bottom-0 w-80 h-80 bg-secondary rounded-full blur-[120px]" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <AnimatedSection>
          <div className="text-center max-w-3xl mx-auto mb-10">
            <div className="inline-flex items-center gap-2 text-primary font-bold tracking-widest text-xs md:text-sm mb-4">
              <FaLaptopCode /> {t('pricingPreview.eyebrow')}
            </div>
            <h2 className="text-3xl md:text-5xl font-bold">{t('pricingPreview.title')}</h2>
            <p className="text-gray-400 mt-4">{t('pricingPreview.subtitle')}</p>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: index * 0.08 }}
              whileHover={{ y: -5 }}
              className={`glass-effect rounded-2xl p-6 text-center ${plan.featured ? 'ring-2 ring-primary/70' : ''}`}
            >
              <h3 className="text-xl font-bold mb-3">{t(`pricingPreview.${plan.key}`)}</h3>
              <div className="text-gray-400 text-sm mb-1">{t('pricingPreview.from')}</div>
              <div className="text-4xl font-bold text-gradient">{plan.price} EUR</div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-gray-500 text-sm max-w-2xl mx-auto mb-6">{t('pricingPreview.note')}</p>
          <motion.a
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            href="/izrada-sajtova"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-primary to-secondary font-semibold text-white hover-glow"
          >
            {t('pricingPreview.cta')} <FaArrowRight />
          </motion.a>
        </div>
      </div>
    </section>
  );
}
